import React from "react";
import { createPortal } from "react-dom";
import { AssetItemProps } from "../asset-item";
import { BarDisplay } from "./bar-display";
import styles from "./bar.module.css";

export const BarSmall: React.FC<AssetItemProps> = ({
  asset,
  onEventStart,
  processLinesRef,
}) => {
  const isNotDelay = asset.type == "taskLine" && asset.source.eventCode !== "D";
  const borderRadius = isNotDelay ? 0 : asset.barCornerRadius;
  const subEventsHeight = isNotDelay ? 6 : asset.height;
  const subEventY = isNotDelay ? asset.y + asset.height - 7 : asset.y;
  return (
    <g
      className={styles.barWrapper}
      tabIndex={0}
      data-event-code={asset.source.eventCode}
    >
      {asset.drawLine &&
        createPortal(
          <line
            x1={0}
            y1={asset.y + asset.height / 2}
            x2={9999}
            y2={asset.y + asset.height / 2}
            stroke="black"
            strokeOpacity={0.3}
            strokeWidth={1}
            pointerEvents="none"
          />,
          processLinesRef.current || document.body,
        )}
      <BarDisplay
        id={`bar-${asset.id}`}
        x={asset.x1}
        y={subEventY}
        width={asset.x2 - asset.x1}
        height={subEventsHeight}
        progressX={asset.progressX}
        progressWidth={asset.progressWidth}
        barCornerRadius={borderRadius}
        styles={asset.styles}
      />

      <g className="handleGroup"></g>
    </g>
  );
};
